module.exports = __webpack_public_path__ + "img/flowpay.bd88b37c.png";